import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { Actions, Link } from 'ui-kit/actions'
import { Picture } from 'ui-kit/picture'
import { BookCalendlyLink } from 'routes/components/Shared'
import { DOCS_LINK } from 'routes/constants'
import HeroMobImage from './hero-mob.avif'
import HeroDeskImage from './hero-desk.avif'
import classes from './SelfHostingHero.module.scss'

export const SelfHostingHero = () => {
  return (
    <Block as={'section'} divider={'mobile'} className={classes.section}>
      <div className={classes.content}>
        <Heading
          as={'h1'}
          size={'xxl'}
          center
          balance
          className={classes.title}
        >
          The full power of a universal integration platform on your
          infrastructure
        </Heading>

        <Actions className={classes.actions}>
          <BookCalendlyLink type={'primary'} className={classes.button}>
            Book a demo
          </BookCalendlyLink>
          <Link
            href={`${DOCS_LINK}/self-hosting`}
            type={'secondary'}
            target={'_blank'}
            asPageButton
            className={classes.button}
          >
            Read the self-hosting docs
          </Link>
        </Actions>
      </div>

      <div className={classes.visual}>
        <Picture
          mobSvg={HeroMobImage.src}
          deskSvg={HeroDeskImage.src}
          className={classes.image}
          alt='The full power of a universal integration platform'
          fetchPriorityHigh
        />
      </div>
    </Block>
  )
}
